import React from "react";
import * as Icons from "lucide-react";
import { skills } from "../mock";
import { Reveal } from "../hooks/useReveal";

const marqueeWords = [
  "Créative", "Réactive", "Organisée", "Curieuse", "Autonome", "Polyvalente", "À l'écoute", "Travail d'équipe",
];

export default function Skills() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* marquee band */}
      <div className="mb-20 border-y border-[#E7D8C6] py-5 overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee">
          {[...marqueeWords, ...marqueeWords].map((w, i) => (
            <span key={i} className="mx-6 font-serif-display text-3xl md:text-4xl text-[#B79A80] italic">
              {w} <span className="text-[#B0603F] not-italic">•</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="text-center mb-16">
          <span className="font-body text-xs tracking-luxe uppercase text-[#B0603F]">Profil</span>
          <h2 className="font-serif-display text-5xl md:text-7xl font-light text-[#3A302A] mt-3">
            Ce qui me définit
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {skills.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Star;
            return (
              <Reveal key={s.key} delay={i * 60}>
                <div className="group h-full bg-[#FAF5EF] border border-[#E7D8C6] rounded-2xl p-7 hover:border-[#B0603F] hover:shadow-[0_20px_50px_-25px_rgba(58,48,42,0.4)] transition-all duration-400 hover:-translate-y-1">
                  <span className="inline-flex w-12 h-12 rounded-full bg-[#F3E9DD] items-center justify-center text-[#B0603F] group-hover:bg-[#B0603F] group-hover:text-[#FAF5EF] transition-colors duration-400">
                    <Icon size={22} />
                  </span>
                  <h3 className="font-serif-display text-2xl text-[#3A302A] mt-5 mb-3">{s.title}</h3>
                  <p className="font-body text-sm text-[#6B5D53] leading-relaxed">{s.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
